var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,8.1c-0.1,0.1-2.6,1.5-2.6,4.6c0,3.6,3.1,4.8,3.2,4.9c0,0.1-0.5,1.7-1.6,3.4c-1,1.5-2.1,3-3.7,3S14.4,23,12.5,23 c-1.8,0-2.5,1-4,1s-2.5-1.4-3.7-3c-1.4-2-2.5-5-2.5-7.9c0-4.7,3-7.1,6-7.1c1.6,0,2.9,1,3.9,1c0.9,0,2.4-1.1,4.2-1.1 C17.1,5.8,19.6,5.8,21.2,8.1z M15.6,3.8c0.7-0.9,1.3-2.1,1.3-3.3c0-0.2,0-0.3,0-0.5c-1.2,0-2.7,0.8-3.5,1.8C12.6,2.5,12,3.8,12,5 c0,0.2,0,0.4,0,0.4c0.1,0,0.2,0,0.3,0C13.4,5.5,14.8,4.8,15.6,3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.f944e73be1617f990f4f7702c2f36ac1.svg";
export { ForwardRef as ReactComponent };